import React, { useContext } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { ReactDatePicker } from '@mummssoftware/common-ui';
import { dateToYYYYMMDD, parseDateYYYYMMDD } from '@mummssoftware/utils/dates';
import { EditContext } from '.';

export const DateRenderer = (params: ICellRendererParams) => {
  const { editState, setEditState } = useContext(EditContext);

  const editing = editState && params.node.rowPinned === 'top';

  const handleChange = (date: Date) => {
    if (editState) {
      setEditState({
        ...editState,
        incidentdatetime_utc: dateToYYYYMMDD(date),
      });
    }
  };

  return (
    <div style={{ width: '100%', minWidth: 0, boxSizing: 'border-box' }}>
      {editing ? (
        <ReactDatePicker
          portalId="root"
          inputTextAlign="unset"
          inputWidth="clamp(120px, 100%, 10rem)"
          popperPosition="fixed"
          selectedDate={parseDateYYYYMMDD(editState.incidentdatetime_utc)}
          onChange={handleChange}
          dateFormat="yyyy-MM-dd"
        />
      ) : (
        params.value
      )}
    </div>
  );
};
